/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Group_ToolsInputs */

const en_sidebar_group_tools = /** @type {(inputs: Sidebar_Group_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

const ko_sidebar_group_tools = /** @type {(inputs: Sidebar_Group_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도구`)
};

const ja_sidebar_group_tools = /** @type {(inputs: Sidebar_Group_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツール`)
};

/**
* | output |
* | --- |
* | "Tools" |
*
* @param {Sidebar_Group_ToolsInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_group_tools = /** @type {((inputs?: Sidebar_Group_ToolsInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Group_ToolsInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_group_tools(inputs)
	if (locale === "ko") return ko_sidebar_group_tools(inputs)
	return ja_sidebar_group_tools(inputs)
});